var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-2",class:{full: _vm.full}},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }